import * as TransferItemsHelper from '@wetransfer/transfer/helper/transfer-items';
import Transform from '@wetransfer/transfer/transformers';

export const getTransfer = () => {
  const sideloaded = window['__session__'] || {};
  const auth = Transform.auth(sideloaded.user);
  const accountId = auth.account.id;

  // initial Transfer state
  return {
    files: [],
    items: [],
    itemsTree: TransferItemsHelper.buildItemsTree(),
    sender: '',
    message: '',
    recipients: [],
    state: null,
    parent_id: null,
    userType: '',
    accountId,
    shortURL: null,
    type: null,
    id: null,
    paid: false,
  };
};

export default getTransfer();
